import { render, staticRenderFns } from "./NeedFeedback.vue?vue&type=template&id=b9a28564&"
import script from "./NeedFeedback.vue?vue&type=script&lang=js&"
export * from "./NeedFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports